import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  client_inactive,
  client_active,
  home_active,
  home_Deactive,
  recharge_active,
  recharge_inactive,
  withdraw_active,
  withdraw_inactive,
  report_active,
  report_inactive,
} from "../../assets/img";
import useStore from "../../Screen/redux/store/useStore";
import { MaskIcon } from "../MaskIcon";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("home");
  const { role, user, permissions } = useStore();

  //   console.log("Footer permissions:", permissions);

  const pathToTab = {
    "/mobile-navbar": "home",
    "/client-list": "clients",
    "/recharge-history": "recharge",
    "/withdraw-history": "withdraw",
    "/report": "report",
  };

  const tabs = [
    {
      id: "home",
      label: "Home",
      route: "home",
      path: "/mobile-navbar",
      activeIcon: home_active,
      inactiveIcon: home_Deactive,
    },
    {
      id: "client",
      label: "Client List",
      path: "/client-list",
      route: "clients",
      activeIcon: client_active,
      inactiveIcon: client_inactive,
    },
    {
      id: "recharge_history",
      label: "Recharge",
      path: "/recharge-history",
      route: "recharge",
      activeIcon: recharge_active,
      inactiveIcon: recharge_inactive,
    },
    {
      id: "widraw_history",
      label: "Withdraw",
      path: "/withdraw-history",
      route: "withdraw",
      activeIcon: withdraw_active,
      inactiveIcon: withdraw_inactive,
    },
    {
      id: "reports",
      label: "Report",
      path: "/report",
      route: "report",
      activeIcon: report_active,
      inactiveIcon: report_inactive,
    },
  ];

  const getTabPermission = (tabId) => {
    //     console.log("Checking permission for tab:", tabId);
    if (tabId === "home") return true;
    if (role === true) return true;

    const perm = permissions.find((p) => p.module_code === tabId);
    return !!perm;
  };

  useEffect(() => {
    const currentTab = pathToTab[location.pathname] || "home";
    setActiveTab(currentTab);
  }, [location.pathname]);

  return (
    
    <div className="footer-container">
      <svg width="0" height="0" style={{ position: "absolute" }}>
  <defs>
    <filter id="brand-color" x="0" y="0" width="100%" height="100%">
      <feFlood floodColor="#8F0D3D" floodOpacity="1" result="color" />
      <feComposite in="color" in2="SourceGraphic" operator="in" />
    </filter>
  </defs>
</svg>
  {tabs.map((tab) => {
    const hasPermission = getTabPermission(tab.id);
    const isActive = activeTab === tab.route;

    return (
      
      <div
        key={tab.route}
        className={`footer-item ${isActive ? "active" : ""} ${
          !hasPermission ? "disabled" : ""
        }`}
        onClick={() =>
          hasPermission &&
          navigate(tab.path, { state: { fromFooter: true } })
        }
      >
        {isActive ? (
          <img
            src={tab.activeIcon}
            width={22}
            height={22}
            alt={tab.label}
            style={{
              filter: "url(#brand-color)",
            }}
          />
        ) : (
          <img
            src={tab.inactiveIcon}
            width={22}
            height={22}
            alt={tab.label}
            style={{ opacity: !hasPermission ? 0.4 : 1 }}
          />
        )}
        <p className="footer-label">{tab.label}</p>
      </div>
    );
  })}
</div>
  );
};

export default Footer;
